module.exports = __webpack_public_path__ + "img/bg.630b0d6e.jpg";